<template>
  <div class="orders-container">
    <nav-bar/>
    <div class="container">
     <div class="orders-content">
      <left-panel :current-index="3"></left-panel>
      <div class="orders-list">
        <div class="list-header color_40">全部订单</div>
        <template >
          <no-choose v-if='ordersList.length === 0 ' :text='"暂无订单"'/>
          <div class="container" v-else-if="ordersList.length > 0" v-loading="listLoading">
            <div class="order_content" >
            <div class="order_item" v-for="(item, index) in ordersList" :key='index' >
              <div class="item_name">
                <div class="det_1">{{item.order.created_at.substr(0,10)}}</div>
                <div class="det_2">订单号</div>
                <div class="det_3">价格</div>
                <div class="det_4">状态</div>
              </div>
              <div class="item_detail">
                <div class="det_1">{{item.order.display_plan}}</div>
                <div class="det_2">{{item.order.trade_no}}</div>
                <div class="det_3">¥ {{item.order.final_price / 100}}</div>
                <div class="det_4" v-if="item.order.aasm_state ==='paid'" style="color:#4183FF; ">
                  <a v-if="item.order.model_name === 'ImprovedOrders'"
                    :href="memberOrderDetailLink(item.order)"
                    style="color:#4183FF;cursor: pointer;"> 订单详情</a>
                  <!-- is_cv_optimization 是否选择了简历服务 -->
                  <!-- is_cv_optimization ? (item.order.cv_not_selected===true || !item.order.question) : state -->
                  <a v-else-if='item.order.model_name==="MentorOrders" && ( item.order.is_cv_optimization ? (item.order.cv_not_selected===true || !item.order.question) : !item.order.is_perfect)' :href=' `/service/pay_success/${item.order.token}`' style="color:#4183FF;cursor: pointer;" target="_blank"> 去完善</a>
                  <a v-else-if='item.order.model_name==="MentorOrders" && ( item.order.is_cv_optimization ? (item.order.cv_not_selected===false && !!item.order.question) : item.order.is_perfect)' :href=' `/service/task/${item.order.token}`' style="color:#4183FF;cursor: pointer;"> 订单详情</a>
                </div>
                <div class="det_4" v-else-if="item.order.aasm_state ==='invalid_order' || item.order.aasm_state ==='refund'" >
                  <p v-if="item.order.aasm_state ==='invalid_order'">订单{{item.order.display_state}}</p>
                  <p v-if="item.order.aasm_state ==='refund'">{{item.order.display_state}}</p>
                </div>
                <div class="det_5" v-else>
                  <div class="payment" @click="paymentOrder(item.order.token,item)">{{item.order.display_state}}</div>
                  <div class="cancel" @click="cancelOrder(item.order.token,item.order.model_name)" ><span>取消订单</span></div>
                </div>

              </div>
              </div>
           </div>
          </div>
           <!--  <order-list class="order-list"></order-list> -->
         <pay-alert v-if="showAlert" @close="closeAlert()" :info='item'></pay-alert>
        </template>
        <div class="page">
       <div class="page-main"  >
          <el-pagination class="page_main"
             background
             :page-size=5
             layout="prev, pager, next"
            :total="total"
              @current-change="handleCurrentChange" v-if='ordersList.length > 0'>
           </el-pagination>
       </div>
      </div>
      </div>

     </div>


    </div>
  </div>
</template>

<script>
	import navBar from '@/components/base/navbar'
	import leftPanel from '../components/leftPanel'
  import pagination from '@/components/newPage'
  import orderList from '../components/orderList'
  import payAlert from "../components/paymentOrder";
  import noChoose from "../components/no_choose";
  import {mapState, mapActions} from "vuex"
	import api from '@/api'
	import { get_tUser, routerTo } from '@/assets/js/util'

	export default {
		name: 'orders',
		data () {
			return {
        item: {},
        type: [],
        ordersList: [],
        listLoading: true,
        total:1,
        page:1,
        size:5,
        showAlert:false
			}
		},
		mounted () {
			this._getOrdersData(this.page)
		},
		computed: {},
		watch: {},
		components: {
			navBar,
			leftPanel,
      pagination,
      orderList,
      pagination,
      payAlert,
      noChoose
    },
    computed:  {
      ...mapState("me", ["personInfo"])
    },
    created(){
      //  this._getOrdersData (this.page)
    },
		methods: {
			// 获取订单列表
			async _getOrdersData (page) {
				let { c_t } = get_tUser()
			/* 	const [ mentor, improved ] = await Promise.all([
					api.account.getOrdersData(c_t, { page:page,size:this.size}),
					api.account.getOrdersData(c_t, { page:page,size:5 })
        ]) */
        this.listLoading = true;
        let improved = await api.account.getOrdersData(c_t, { page:page,size:5 })
              if(improved.code === 1000) {
                this.total = improved.data.count
                //this.type = ['mentor_order','improved_order']
                this.ordersList = improved.data.orders;
                this.listLoading = false;
              }

				//console.log( improved, '----',c_t,this.total,this.ordersList)
      },
      // 页码改变
      handleCurrentChange (page) {
       // console.log(page)
        this._getOrdersData(page)
        this.page = page
      },
      // 取消订单
      async cancelOrder(token,type){
        let { c_t } = get_tUser()
        if (type === 'ImprovedOrders'){
          type = 'improved_order'
        } else {
          type = 'mentor_order'
        }
        let res = await api.account.cancelOrder(c_t, token,{ type })
        console.log(res)

        if (res.code === 1000) {
          this.$message.success("取消订单成功")
          for (let i = 0; i < this.ordersList.length; i++) {
           if (this.ordersList[i].order.token === token) {
             this.ordersList[i].order.aasm_state = "invalid_order"
             this.ordersList[i].order.display_state = "已取消"
           }

          }
        } else {
          this.$message.error(res.message || '取消订单失败')
        }
       // console.log(res,token)
      },
      // 付款
      async paymentOrder(token,item) {
        let { c_t } = get_tUser()
        let res = await api.account.getOrderAlert(c_t,token,{ type: 'improved_order'})
        //console.log(res,this.personInfo)
         this.item = item
         this.showAlert = true

      },
      // 关闭支付
      closeAlert (){
        this.showAlert = false
      },
      // 导师订单完善
      goToComplete (token,item) {
        routerTo(`/service/pay_success/${token}`,'_blank')
      },
      memberOrderDetailLink(order) {
        const { has_rights, member_period, token } = order;
        switch(member_period) {
          case 1:
            return `/pay/success?orderId=${token}&type=${has_rights ? 'rightsMonth' : 'month'}`
          case 12:
            return `/pay/success?orderId=${token}&type=${has_rights ? 'rightsVip' : 'vip'}`
          default:
            return `/pay/success?orderId=${token}&type=super`
        }
      }
		}
	}
</script>

<style lang="scss" scoped>
  @import './index.scss';
</style>
